import { Component, OnInit } from '@angular/core';
import { BaseDefaultListFilterComponent } from 'yt-ng-framework';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { BankaView } from 'src/app/lookups/banka/banka-view';
import { Router } from '@angular/router';

@Component({
  selector: 'app-filter-with-banka',
  templateUrl: './filter-with-banka.component.html'
})
export class FilterWithBankaComponent extends BaseDefaultListFilterComponent{

  constructor(protected datePipe: DatePipe
  ){
    super(datePipe);
}

selectedBanka: string = 'Svi';

  ngOnInit() {
   this.SetInitParameters();
  }

  SelectBanka(item: BankaView){
    this.selectedBanka = item != null ? item.Naziv + ', ' + item.Mesto : 'Svi';
}

  SetFilterDescription(){
    super.SetFilterDescription();
    this.FilterDescription = 'Od: ' + this.GetPropertyValue(this.filterFormGroup.get('DateFrom').value, 'date') + 
                             ', Do: ' + this.GetPropertyValue(this.filterFormGroup.get('DateTo').value, 'date') +
                             ', Banka: ' + this.selectedBanka;
}

SetInitParameters(){
  super.SetInitParameters();
  let date = new Date();
  this.filterFormGroup = new FormGroup({
      DateFrom: new FormControl(new NgbDate(date.getFullYear(), 1, 1), [Validators.required]),
      DateTo: new FormControl(new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate()), [Validators.required]),
      BankaID: new FormControl()
  })
}

}
